<template>
    <main-content>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar class="w-100">
                    <ul class="nav nav-pills d-flex justify-content-between w-100" role="tablist" v-if="$can('read', 'marketing')">
                       
                        <div class="pos-tab d-flex">
                            <li class="nav-item">
                            <a
                                    :class="['nav-link', active_pane === '#pos_agent' ? 'active' : '']"
                                    data-toggle="tab"
                                    @click="gotoTab('#pos_agent')"
                                    href="#pos_agent"
                                    role="tab"
                                    aria-selected="false"
                            >
                                {{ $t("aside.pos_agent") }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                    :class="['nav-link', active_pane === '#pos_setting' ? 'active' : '']"
                                    data-toggle="tab"
                                    @click="gotoTab('#pos_setting')"
                                    href="#pos_setting"
                                    role="tab"
                                    aria-selected="false"
                            >
                                {{ $t("aside.pos_setting") }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                    :class="['nav-link', active_pane === '#pos_acceptor' ? 'active' : '']"
                                    data-toggle="tab"
                                    @click="gotoTab('#pos_acceptor')"
                                    href="#pos_acceptor"
                                    role="tab"
                                    aria-selected="false"
                            >
                                {{ $t("aside.pos_acceptor") }}
                            </a>
                        </li>
                        </div>
                        <div class="register-acceptor">
                            <li class="nav-item">
                                <button
                                    type="button"
                                    data-toggle="modal"
                                    data-target="#acceptosRegister"
                                    class="btn btn-md btn-success btn-wide"
                            >
                                ثبت پذیرنده
                            </button>
                            </li>
                             <!-- Modal -->
                        <div
                                class="modal fade"
                                id="acceptosRegister"
                                tabindex="-1"
                                role="dialog"
                                aria-labelledby="acceptosRegisterTitle"
                                aria-hidden="true"
                                data-keyboard="false"
                                data-backdrop="static"
                        >
                            <div class="modal-dialog modal-dialog-centered" role="document">
                                <div class="modal-content">
                                    <div class="p-4 d-flex align-items-center justify-content-between">
                                        <h5 class="modal-titles" id="acceptorsHeaderTitle">ثبت پذیرنده</h5>
                                        <span class="close_btn_modal" @click="closeModal">&times;</span>
                                    </div>
                                    <div class="modal-body p-4">
                                        <div class="my-3">
                                            <kt-form-label for="wage my-2"> جستجو پذیرنده </kt-form-label>
                                            <v-select
                                                    v-model="searchUser"
                                                    @input="setSelectedForUser"
                                                    class="vSelect form-control"
                                                    :options="optionsUser"
                                                    :filterable="false"
                                                    @search="onSearchUser"
                                                    :getOptionLabel="(user) => user.id"
                                            >
                                                <template slot="no-options"> کاربر مورد نظر وجود ندارد </template>
                                                <template slot="option" slot-scope="options">
                                                    <div class="d-flex align-items-center">
                                                        {{ options.first_name + " " + options.last_name }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="options">
                                                    <div class="selected d-flex align-items-center">
                                                        {{ options.first_name + " " + options.last_name }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                        <div class="my-3">
                                            <kt-form-label for="wage my-2"> جستجو نماینده </kt-form-label>
                                            <v-select
                                                    v-model="searchAcceptor"
                                                    @input="setSelectedForAcceptor"
                                                    class="vSelect form-control"
                                                    :options="optionsAcceptor"
                                                    :filterable="false"
                                                    @search="onSearchAcceptor"
                                                    :getOptionLabel="(user) => user.id"
                                            >
                                                <template slot="no-options"> کاربر مورد نظر وجود ندارد </template>
                                                <template slot="option" slot-scope="options">
                                                    <div class="d-flex align-items-center">
                                                        {{ options.first_name + " " + options.last_name }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="options">
                                                    <div class="selected d-flex align-items-center">
                                                        {{ options.first_name + " " + options.last_name }}
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                        <div class="my-3">
                                            <kt-form-label for="wage my-2"> شماره ترمینال </kt-form-label>
                                            <kt-form-control
                                                    type="text"
                                                    placeholder=""
                                                    name="visitor_total_wage"
                                                    id="visitor_total_wage"
                                                    max="100"
                                                    v-model="create_acceptor_terminal_number"
                                            >
                                            </kt-form-control>
                                        </div>
                                        <div class="my-3">
                                            <kt-form-label for="wage my-2"> کد پذیرنده </kt-form-label>
                                            <kt-form-control
                                                    type="text"
                                                    placeholder=""
                                                    name="visitor_total_wage"
                                                    id="visitor_total_wage"
                                                    max="100"
                                                    v-model="create_acceptor_acceptor_code"
                                            >
                                            </kt-form-control>
                                        </div>
                                        <div class="my-3">
                                            <kt-form-label for="wage my-2"> نام فروشگاه </kt-form-label>
                                            <kt-form-control
                                                    type="text"
                                                    placeholder=""
                                                    name="visitor_total_wage"
                                                    id="visitor_total_wage"
                                                    max="100"
                                                    v-model="create_acceptor_shop_name"
                                            >
                                            </kt-form-control>
                                        </div>
                                        <div class="my-3">
                                            <kt-form-label for="status"> پی اس پی </kt-form-label>
                                            <kt-form-select
                                                    size="5"
                                                    id="transaction_type"
                                                    class="form-control"
                                                    name="transaction_type"
                                                    v-model="create_acceptor_psp"
                                            >
                                                <option :value="`pasargad`">پاسارگاد</option>
                                            </kt-form-select>
                                        </div>
                                        <fieldset class="border p-2" v-if="create_acceptor_user_id === ''">
                                            <legend class="w-auto px-3" style="font-size: 15px">
                                                اطلاعات پذیرنده
                                            </legend>
                                            <div class="my-3">
                                                <kt-form-label for="status"> نوع </kt-form-label>
                                                <kt-form-select
                                                        size="5"
                                                        id="transaction_type"
                                                        class="form-control"
                                                        name="transaction_type"
                                                        v-model="create_acceptor_user_type"
                                                >
                                                    <option :value="1">حقیقی</option>
                                                    <option :value="2">حقوقی</option>
                                                </kt-form-select>
                                            </div>
                                            <div class="my-3">
                                                <kt-form-label for="wage my-2"> نام </kt-form-label>
                                                <kt-form-control
                                                        type="text"
                                                        placeholder=""
                                                        name="visitor_total_wage"
                                                        id="visitor_total_wage"
                                                        max="100"
                                                        v-model="create_acceptor_first_name"
                                                >
                                                </kt-form-control>
                                            </div>
                                            <div class="my-3">
                                                <kt-form-label for="wage my-2"> نام خانوادگی </kt-form-label>
                                                <kt-form-control
                                                        type="text"
                                                        placeholder=""
                                                        name="visitor_total_wage"
                                                        id="visitor_total_wage"
                                                        max="100"
                                                        v-model="create_acceptor_last_name"
                                                >
                                                </kt-form-control>
                                            </div>
                                            <div class="my-3">
                                                <kt-form-label for="wage mt-5"> نام شرکت </kt-form-label>
                                                <kt-form-control
                                                        type="text"
                                                        placeholder=""
                                                        name="visitor_total_wage"
                                                        id="visitor_total_wage"
                                                        max="100"
                                                        v-model="create_acceptor_com_name_fa"
                                                >
                                                </kt-form-control>
                                            </div>
                                            <div class="my-3">
                                                <kt-form-label for="wage my-2"> موبایل </kt-form-label>
                                                <kt-form-control
                                                        type="text"
                                                        placeholder=""
                                                        name="visitor_total_wage"
                                                        id="visitor_total_wage"
                                                        max="100"
                                                        v-model="create_acceptor_phone"
                                                >
                                                </kt-form-control>
                                            </div>
                                        </fieldset>
                                    </div>
                                    <div class="p-4 d-flex">
                                        <button
                                                type="button"
                                                class="btn btn-md btn-success btn-wide"
                                                @click="createAcceptor"
                                        >
                                            ثبت
                                        </button>
                                        <button
                                                type="button"
                                                class="btn btn-md btn-primary btn-wide mx-2"
                                                @click="closeModal"
                                        >
                                            بستن
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </ul>
                    <ul
                            class="nav nav-pills"
                            role="tablist"
                            v-else-if="$can('read', 'pos-visitor')"
                    >
                        <li class="nav-item">
                            <a
                                    :class="[
                  'nav-link',
                  active_pane === '#pos_acceptor_visitor' ? 'active' : '',
                ]"
                                    data-toggle="tab"
                                    @click="gotoTab('#pos_acceptor_visitor')"
                                    href="#pos_acceptor_visitor"
                                    role="tab"
                                    aria-selected="false"
                            >
                                پذیرندگان دستگاه کارتخوان
                            </a>
                        </li>
                    </ul>
                    <ul class="nav nav-pills" role="tablist" v-else>
                        <li class="nav-item">
                            <a
                                    :class="[
                  'nav-link',
                  active_pane === '#pos_acceptor_user' ? 'active' : '',
                ]"
                                    data-toggle="tab"
                                    @click="gotoTab('#pos_acceptor_user')"
                                    href="#pos_acceptor"
                                    role="tab"
                                    aria-selected="false"
                            >
                                دستگاه های کارتخوان
                            </a>
                        </li>
                    </ul>
                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <div class="tab-content">
                    <!-- pos basic user -->
                    <div
                            :class="['tab-pane', active_pane === '#pos_acceptor_user' ? 'active' : '']"
                            id="user_info"
                    >
                        <user-filter :action="filterAction"></user-filter>
                        <kt-row>
                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="kt-portlet">
                                    <div
                                            class="kt-portlet__body"
                                            style="color: black; background-color: #fff"
                                    >
                                        <h6>{{ "تعداد تراکنش ها" }}</h6>
                                        <div class="text-center">
                                            <h4 class="fix-margin">
                                                {{ posStatistics.transactions_number }}
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <accounting-statistics
                                        :accountingStatistics="posStatistics.total_transactions_amount"
                                        :title="$t('aside.pos_total_transactions_amount')"
                                />
                            </div>
                        </kt-row>
                        <div class="switch-div" v-if="$can('read','pos-visitor')">
                            زیرمجموعه ها
                            <label class="switch m-0 mr-2 ml-2">
                                <input id="settlement_checkbox" type="checkbox" v-model="checked" />
                                <span class="slider round"></span>
                            </label>
                            خودم
                        </div>
                        <div>
                            <kt-datatable
                                    v-if="active_pane === '#pos_acceptor_user'"
                                    v-bind="dataTableForUser"
                                    ref="datatable"
                            >
                            </kt-datatable>
                        </div>
                    </div>
                    <!-- pos visitor -->
                    <div
                            :class="['tab-pane', active_pane === '#pos_acceptor_visitor' ? 'active' : '']"
                            id="user_info"
                    >
                        <visitor-filter :action="filterAction"></visitor-filter>
                        <kt-row>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <accounting-statistics
                                        :accountingStatistics="posStatistics.total_visitor_wage"
                                        :title="$t('aside.pos_total_visitor_wage')"
                                />
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <accounting-statistics
                                        :accountingStatistics="posStatistics.total_transactions_amount"
                                        :title="$t('aside.pos_total_transactions_amount')"
                                />
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4">
                                <div class="kt-portlet">
                                    <div
                                            class="kt-portlet__body"
                                            style="color: black; background-color: #fff"
                                    >
                                        <h6>{{ "تعداد تراکنش ها" }}</h6>
                                        <div class="text-center">
                                            <h4 class="fix-margin">
                                                {{ posStatistics.transactions_number }}
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </kt-row>
                        <div class="switch-div" v-if="$can('read','pos-visitor')">
                            زیرمجموعه ها
                            <label class="switch m-0 mr-2 ml-2">
                                <input id="settlement_checkbox" type="checkbox" v-model="checked" />
                                <span class="slider round"></span>
                            </label>
                            خودم
                        </div>
                        <div>
                            <kt-datatable
                                    v-if="active_pane === '#pos_acceptor_visitor'"
                                    v-bind="dataTableForVisitor"
                                    ref="datatable"
                            >
                            </kt-datatable>
                        </div>
                    </div>
                    <div
                            :class="['tab-pane', active_pane === '#pos_agent' ? 'active' : '']"
                            id="user_info"
                    >
                        <div v-if="$can('read', 'marketing')">
                            <agent-filter :action="filterAction" />
                        </div>
                        <div v-else>
                            <common-filter :action="filterAction" />
                        </div>
                        <div>
                            <kt-row v-if="$can('read', 'marketing')">
                                <div class="col-lg-4 col-md-6 col-sm-6">
                                    <accounting-statistics
                                            :accountingStatistics="posStatistics.net_profit"
                                            :title="$t('aside.pos_net_profit')"
                                    />
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-6">
                                    <accounting-statistics
                                            :accountingStatistics="posStatistics.total_profit"
                                            :title="$t('aside.pos_total_profit')"
                                    />
                                </div>
                                <div class="col-lg-4 -md-6 col-sm-6">
                                    <accounting-statistics
                                            :accountingStatistics="posStatistics.total_transactions_amount"
                                            :title="$t('aside.pos_total_transactions_amount')"
                                    />
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <accounting-statistics
                                            :accountingStatistics="posStatistics.total_visitor_wage"
                                            :title="$t('aside.pos_total_visitor_wage')"
                                    />
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="kt-portlet">
                                        <div
                                                class="kt-portlet__body"
                                                style="color: black; background-color: #fff"
                                        >
                                            <h6>{{ "تعداد تراکنش ها" }}</h6>
                                            <div class="text-center">
                                                <h4 class="fix-margin">
                                                    {{ posStatistics.transactions_number }}
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </kt-row>
                            <div v-if="active_pane === '#pos_agent'">
                                <kt-datatable
                                        v-if="$can('read', 'marketing')"
                                        v-bind="datatableManagePropsAgent"
                                        ref="datatable"
                                >
                                </kt-datatable>
                            </div>
                        </div>
                    </div>
                    <div :class="['tab-pane', active_pane === '#pos_setting' ? 'active' : '']">
                        <kt-row>
                            <kt-col class="mt-2 sepread_part" xs="12" sm="12" md="12">
                                <div>
                                    <label
                                            for="file"
                                            class="d-block btn btn-outline-success btn-pill label-file mx-auto"
                                    >
                                        <kt-icon type="fa" name="paperclip"></kt-icon>
                                        {{ "اپلود اکسل گزارش تراکنش پذیرندگان" }}
                                    </label>
                                    <input
                                            @change="processExcelFile"
                                            type="file"
                                            class="custom-file-upload d-none"
                                            name="file"
                                            id="file"
                                            accept=".xlsx"
                                    />
                                </div>
                                <kt-col xs="12" sm="6" md="4" class="mx-auto">
                                    <kt-form-group ref="statusSelectGroup" class="mt-3">
                                        <kt-form-label for="status">
                                            {{ $t("label.psp") }}
                                        </kt-form-label>
                                        <kt-form-select
                                                size="5"
                                                id="transaction_type"
                                                class="form-control"
                                                name="transaction_type"
                                                v-model="pspName"
                                        >
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(psp_type, index) in pspTypes"
                                                    v-bind:value="psp_type.value"
                                                    :selected="query.psp_type === psp_type.value"
                                            >
                                                {{ psp_type.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                                <div class="d-flex align-items-center justify-content-center mb-4">
                                    <button
                                            id="uploadBtn"
                                            class="btn btn-md btn-success btn-wide"
                                            @click="uploadFile"
                                    >
                                        آپلود فایل
                                    </button>
                                </div>
                            </kt-col>
                            <kt-col xs="6" md="6" sm="6" class="mt-4 ml-4 pl-3">
                                <kt-form-label for="wage"> کارمزد عمومی نمایندگان (ریال) </kt-form-label>
                                <kt-form-control
                                        type="text"
                                        placeholder=""
                                        name="visitor_total_wage"
                                        id="visitor_total_wage"
                                        max="100"
                                        v-model="visitor_total_wage"
                                >
                                </kt-form-control>
                            </kt-col>
                            <kt-col xs="12" md="12" sm="12" class="mt-4 p-1 sepread_part"></kt-col>
                            <kt-col xs="12" md="12" sm="12" class="mt-4">
                                <h5 class="ml-4 pl-1 mb-4">کارمزد دریافتی از پی اس پی</h5>
                                <form @submit.prevent class="kt-form" id="marketer_wage">
                                    <kt-row
                                            v-for="wage in wages"
                                            :key="wage.id"
                                            lg="12"
                                            md="12"
                                            xs="12"
                                            class="align-items-center p-3 p-sm-0 mt-4 mt-sm-0 rowMe"
                                    >
                                        <input
                                                type="text"
                                                disabled
                                                :value="wage.period_number"
                                                class="text-center border-0 bg-white d-none d-sm-block"
                                                style="width: 25px"
                                        />
                                        <kt-col class="col-12 col-sm-4">
                                            <kt-form-section>
                                                <kt-form-group>
                                                    <kt-form-label for="period-duration-days">
                                                        {{ $t("marketing.marketing_wage.period_duration") }}
                                                    </kt-form-label>
                                                    <kt-form-control
                                                            type="number"
                                                            name="period-duration-days"
                                                            id="period-duration-days"
                                                            v-model="wage.from"
                                                    >
                                                    </kt-form-control>
                                                </kt-form-group>
                                            </kt-form-section>
                                        </kt-col>
                                        <kt-col class="col-12 col-sm-4">
                                            <kt-form-section>
                                                <kt-form-group>
                                                    <kt-form-label for="wage">
                                                        {{ $t("marketing.marketing_wage.wage") }}
                                                    </kt-form-label>
                                                    <kt-form-control
                                                            type="text"
                                                            placeholder=""
                                                            name="wage"
                                                            id="wage"
                                                            max="100"
                                                            v-model="wage.wage"
                                                    >
                                                    </kt-form-control>
                                                </kt-form-group>
                                            </kt-form-section>
                                        </kt-col>
                                        <input
                                                style="width: 15px; height: 15px"
                                                :checked="wage.to"
                                                :ref="`to${wage.id}`"
                                                type="radio"
                                                name="to"
                                                :title="$t('marketing.marketing_wage.infininte')"
                                        />
                                        <div class="d-flex flex-nowrap">
                                            <button
                                                    @click="deleteItem(wage)"
                                                    title="حذف"
                                                    type="button"
                                                    class="btn btn-label-danger trash-btn ml-3"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <button
                                                    :id="`update-wage${wage.id}`"
                                                    type="button"
                                                    @click="updateItem(wage)"
                                                    style="cursor: pointer"
                                                    class="btn btn-info ml-2"
                                                    v-text="$t('marketing.marketing_wage.update')"
                                            ></button>
                                        </div>
                                    </kt-row>
                                    <hr class="my-5" v-if="newWages.length > 0 && wages.length > 0" />
                                    <kt-row
                                            v-for="wage in newWages"
                                            :key="wage.id"
                                            lg="12"
                                            md="12"
                                            xs="12"
                                            class="align-items-center p-3 p-sm-0 mt-4 mt-sm-0 rowMe"
                                    >
                                        <input
                                                type="text"
                                                disabled
                                                :value="wage.period_number"
                                                class="text-center border-0 bg-white"
                                                style="width: 25px"
                                        />
                                        <kt-col xs="12" sm="6" md="3">
                                            <kt-form-group ref="statusSelectGroup">
                                                <kt-form-label for="status">
                                                    {{ $t("label.psp") }}
                                                </kt-form-label>
                                                <kt-form-select
                                                        size="5"
                                                        id="transaction_type"
                                                        class="form-control"
                                                        name="transaction_type"
                                                        v-model="wage.pspName"
                                                >
                                                    <option
                                                            v-bind:key="index"
                                                            v-for="(psp_type, index) in pspTypes"
                                                            v-bind:value="psp_type.value"
                                                            :selected="query.psp_type === psp_type.value"
                                                    >
                                                        {{ psp_type.name }}
                                                    </option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col class="col-12 col-sm-2">
                                            <kt-form-section>
                                                <kt-form-group>
                                                    <kt-form-label for="period-duration-days">
                                                        از تعداد تراکنش
                                                    </kt-form-label>
                                                    <kt-form-control
                                                            type="number"
                                                            name="period-duration-days"
                                                            id="period-duration-days"
                                                            v-model="wage.from"
                                                            max="100"
                                                    >
                                                    </kt-form-control>
                                                </kt-form-group>
                                            </kt-form-section>
                                        </kt-col>
                                        <kt-col class="col-12 col-sm-2">
                                            <kt-form-section>
                                                <kt-form-group>
                                                    <kt-form-label for="period-duration-days">
                                                        تا تعداد تراکنش
                                                    </kt-form-label>
                                                    <kt-form-control
                                                            type="number"
                                                            name="period-duration-days"
                                                            id="period-duration-days"
                                                            v-model="wage.to"
                                                            max="100"
                                                    >
                                                    </kt-form-control>
                                                </kt-form-group>
                                            </kt-form-section>
                                        </kt-col>
                                        <kt-col class="col-12 col-sm-3">
                                            <kt-form-section>
                                                <kt-form-group>
                                                    <kt-form-label for="wage"> مبلغ (ریال) </kt-form-label>
                                                    <kt-form-control
                                                            type="text"
                                                            placeholder=""
                                                            name="wage"
                                                            id="wage"
                                                            max="100"
                                                            v-model="wage.wage"
                                                    >
                                                    </kt-form-control>
                                                </kt-form-group>
                                            </kt-form-section>
                                        </kt-col>


                                        <div class="d-flex flex-nowrap">
                                            <button
                                                    @click="deleteNewItem(wage)"
                                                    title="حذف"
                                                    type="button"
                                                    class="btn btn-label-danger trash-btn ml-3"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                        </div>
                                    </kt-row>
                                    <kt-row>
                                        <div class="w-100 d-flex align-items-center justify-content-center">
                                            <button
                                                    type="button"
                                                    @click="addWage()"
                                                    class="btn btn-outline-success mt-3 ml-3"
                                                    v-text="$t('marketing.marketing_wage.add_wage')"
                                            ></button>
                                        </div>
                                    </kt-row>
                                </form>
                            </kt-col>
                        </kt-row>
                        <kt-col xs="12" sm="6" md="6">
                            <button
                                    class="btn btn-md btn-success btn-wide mt-5"
                                    type="submit"
                                    id="sheba_btn"
                                    @click="setPosWage"
                            >
                                {{ $t("tag.submit") }}
                            </button>
                        </kt-col>
                    </div>
                    <div :class="['tab-pane', active_pane === '#pos_acceptor' ? 'active' : '']">
                        <div v-if="$can('read', 'marketing')">
                            <acceptor-filter :action="filterAction" />
                        </div>
                        <div v-if="active_pane === '#pos_acceptor'">
                            <kt-datatable
                                    v-if="$can('read', 'marketing')"
                                    v-bind="datatableManageProps"
                                    ref="datatable"
                            >
                            </kt-datatable>
                        </div> 
                    </div>
                </div>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
    import mainContent from "@/components/main-content";
    import commonFilter from "./components/common-filter";
    import { mapGetters } from "vuex";
    import CommonFilter from "./components/common-filter";
    import manageAccessColumns from "./datatable/manageAccessColumns";
    import manageAccessColumnsAgent from "./datatable/manageAccessColumnsAgent";
    import { ApiUrl } from "@/common/api.service";
    import { AuthorizationHeader } from "@/common/jwt.service";
    import IranSheba from "iran-sheba";
    import { marketingService } from "@/common/api.service";
    import toastr from "toastr";
    import $ from "jquery";
    import { KTApp } from "@/plugins/core/app";
    import { i18n } from "@/plugins/i18n";
    import agentFilter from "./components/agent-filter.vue";
    import AgentFilter from "./components/agent-filter.vue";
    import acceptorFilter from "./components/acceptor-filter.vue";
    import AcceptorFilter from "./components/acceptor-filter.vue";
    import statistics from "../reports/components/accounting-statistics.vue";
    import { ApiService, userService } from "@/common/api.service";
    import _ from "lodash";
    import userFilter from "./components/user-filter.vue";
    import userAccessColumn from "./datatable/userAccessColumn";
    import visitorFilter from "./components/visitor-filter.vue";
    import visitorAccessColumn from "./datatable/visitorAccessColumn";

    export default {
        name: "MarketingDashboard",
        components: {
            CommonFilter,
            AgentFilter,
            AcceptorFilter,
            "main-content": mainContent,
            "common-filter": commonFilter,
            "agent-filter": agentFilter,
            "acceptor-filter": acceptorFilter,
            "accounting-statistics": statistics,
            userFilter,
            visitorFilter,
        },
        data() {
            return {
                active_pane: "#pos_agent",
                headerAction: {
                    left: "10px",
                    top: "10px",
                    position: "absolute",
                },
                query: {
                    sheba_id: null,
                    file: null,
                },
                searchUser: "",
                searchAcceptor: "",
                filter_sheba_number: null,
                sheba_id: null,
                wages: [],
                pspName: "pasargad",
                newWages: [],
                psp_total_wage: {
                    pasargad: [],
                    // parsian: [],
                },
                excel: null,
                visitor_total_wage: "",
                fetchPosWage: {},
                pspTypes: [
                    {
                        name: "پاسارگاد",
                        value: "pasargad",
                    },
                ],
                // for create acceptor
                create_acceptor_user_id: "",
                create_acceptor_visitor_id: "",
                create_acceptor_terminal_number: "",
                create_acceptor_acceptor_code: "",
                create_acceptor_shop_name: "",
                create_acceptor_psp: "pasargad",
                create_acceptor_user_type: "",
                create_acceptor_first_name: "",
                create_acceptor_last_name: "",
                create_acceptor_com_name_fa: "",
                create_acceptor_phone: "",
                have_user_register: false,
                optionsUser: [],
                optionsAcceptor: [],
                checked: true,
            };
        },
        watch: {
            filter_sheba_number(value) {
                this.query.sheba_id = value.id;
            },
            checked(value) {
                if (value) {
                    this.active_pane = "#pos_acceptor_visitor";
                } else {
                    this.active_pane = "#pos_acceptor_user";
                }
            },
        },
        computed: {
            ...mapGetters("shebaNumber", ["sheba_numbers"]),
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false,
                };

                return toastr;
            },
            disabledInput() {
                return this.create_acceptor_user_id;
            },
            datatableProps() {
                return {
                    id: "subsets_datatable",
                    data: {
                        type: "remote",
                        source: {
                            read: {
                                url: ApiUrl.starshopPath("marketing/pos-acceptor"),
                                method: "GET",
                                headers: AuthorizationHeader,
                                map: function (res) {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            },
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: manageAccessColumns,
                };
            },
            datatablePropsAgent() {
                return {
                    id: "subsets_datatable",
                    data: {
                        type: "remote",
                        source: {
                            read: {
                                url: ApiUrl.starshopPath("marketing/pos-visitor"),
                                method: "GET",
                                headers: AuthorizationHeader,
                                map: function (res) {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            },
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: manageAccessColumnsAgent,
                };
            },
            datatableManageProps() {
                return {
                    id: "marketers_datatable",
                    data: {
                        type: "remote",
                        source: {
                            read: {
                                url: ApiUrl.starshopPath("marketing/pos-acceptor"),
                                method: "GET",
                                headers: AuthorizationHeader,
                                map: function (res) {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            },
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: manageAccessColumns,
                };
            },
            datatableManagePropsAgent() {
                return {
                    id: "marketers_datatable",
                    data: {
                        type: "remote",
                        source: {
                            read: {
                                url: ApiUrl.starshopPath("marketing/pos-visitor"),
                                method: "GET",
                                headers: AuthorizationHeader,
                                map: function (res) {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            },
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: manageAccessColumnsAgent,
                };
            },
            dataTableForUser() {
                return {
                    id: "marketers_datatable",
                    data: {
                        type: "remote",
                        source: {
                            read: {
                                url: ApiUrl.starshopPath("marketing/pos-acceptor?my-acceptor=true"),
                                method: "GET",
                                headers: AuthorizationHeader,
                                map: function (res) {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            },
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: userAccessColumn,
                };
            },
            dataTableForVisitor() {
                return {
                    id: "marketers_datatable",
                    data: {
                        type: "remote",
                        source: {
                            read: {
                                url: ApiUrl.starshopPath("marketing/pos-acceptor"),
                                method: "GET",
                                headers: AuthorizationHeader,
                                map: function (res) {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            },
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: visitorAccessColumn,
                };
            },
            ...mapGetters("marketing", ["data", "status", 'posStatistics']),
        },
        methods: {
            checkbox_changed(e) {
                let checkbox = $("#settlement_checkbox");

                if (checkbox.is(":checked")) {
                    this.active_pane = "#pos_acceptor_visitor";
                } else {
                    this.active_pane = "#pos_acceptor_user";
                }
            },
            closeModal() {
                $("#acceptosRegister").modal("hide");
                (this.create_acceptor_user_id = ""),
                    (this.create_acceptor_visitor_id = ""),
                    (this.create_acceptor_terminal_number = ""),
                    (this.create_acceptor_acceptor_code = ""),
                    (this.create_acceptor_shop_name = ""),
                    (this.create_acceptor_psp = "pasargad"),
                    (this.create_acceptor_user_type = ""),
                    (this.create_acceptor_first_name = ""),
                    (this.create_acceptor_last_name = ""),
                    (this.create_acceptor_com_name_fa = ""),
                    (this.create_acceptor_phone = ""),
                    (this.have_user_register = false);
            },
            setSelectedForUser(value) {
                if (value === null) {
                    this.create_acceptor_user_id = "";
                } else {
                    this.create_acceptor_user_id = value.id;
                }
            },
            setSelectedForAcceptor(value) {
                this.create_acceptor_visitor_id = value.id;
            },
            // vue-select
            // OnSearch for Customers
            onSearchUser(search, loading) {
                this.searchForUser(loading, search, this);
            },
            onSearchAcceptor(search, loading) {
                this.searchForAcceptor(loading, search, this);
            },
            searchForUser: _.debounce((loading, search, vm) => {
                ApiService.query(`user/search?q=${search}`)
                    .then((res) => {
                        vm.optionsUser = res.data;
                        loading(false);
                    })
                    .catch((e) => {
                        throw new Error(e)
                    });
            }, 600),
            searchForAcceptor: _.debounce((loading, search, vm) => {
                ApiService.query(`user/search?q=${search}`)
                    .then((res) => {
                        vm.optionsAcceptor = res.data;
                        loading(false);
                    })
                    .catch((e) => {
                        throw new Error(e)
                    });
            }, 600),
            setPosWage() {
                this.psp_total_wage.pasargad = this.newWages
                let btn = $("#sheba_btn");
                KTApp.progress(btn);
                marketingService
                    .posPublicWage({
                        visitor_total_wage: this.visitor_total_wage,
                        psp_total_wage: this.psp_total_wage,
                    })
                    .then((response) => {
                        KTApp.unprogress(btn);
                        this.toastr.success(response.data.message);
                    })
                    .catch(({ response }) => {
                        KTApp.unprogress(btn);
                        this.toastr.error(response.data.message);
                    });
            },
            filterAction(e, query) {
                this.query = query;
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }
                this.$store.dispatch('marketing/fetchPosStatistics', query)
            },
            gotoTab(selectedTab) {
                this.active_pane = selectedTab;
                window.localStorage.setItem("user_details_active_tab", selectedTab);
            },
            getBankName(number) {
                return IranSheba.recognize(number)["persianName"];
            },
            correctFormatSheba(sheba) {
                return "IR" + sheba.split("-").join("");
            },
            processExcelFile(e) {
                this.excel = e.target.files[0];
                this.validateSize(e.target);
                this.validateFormat(e.target);
            },
            validateSize(file) {
                var FileSize = file.files[0].size / 1024 / 1024; // in MB
                if (FileSize > 1) {
                    alert(i18n.t("money_request.file_size_hint"));
                    $(file).val("");
                } else {
                }
            },
            validateFormat(file) {
                let jq_file = $(file);
                let file_name = jq_file.val();
                let extension = file_name.replace(/^.*\./, "");
                if (extension === file_name) {
                    extension = "";
                } else {
                    extension = extension.toLowerCase();
                }

                switch (extension) {
                    case "xlsx":
                        break;
                    default:
                        alert(i18n.t("authenticate.input_format_err"));
                        $(file).val("");
                }
            },
            excelTemplateLink() {
                return BASE_PATH + "/money-request/download";
            },
            deleteItem(wage) {
                const el = $("#marketer_wage");
                marketingService
                    .deleteWage(wage.id)
                    .then((res) => {
                        this.getWages();
                        this.showMsg(el, "success", res.data.message);
                    })
                    .catch((e) => {
                        this.showMsg(el, "danger", e.response.message);
                    });
            },
            updateItem(wage) {
                const el = $("#marketer_wage");
                let btn = $(`#update-wage${wage.id}`);
                wage.wage = String(wage.wage).replace(/,/g, "");
                wage.user_id = this.$route.params.user_id;
                wage.to = this.$refs[`to${wage.id}`][0].checked;
                KTApp.progress(btn);
                marketingService
                    .updateWage(wage)
                    .then((res) => {
                        KTApp.unprogress(btn);
                        this.getWages();
                        this.showMsg(el, "success", res.data.message);
                    })
                    .catch((e) => {
                        KTApp.unprogress(btn);
                        this.showMsg(el, "danger", e.response.message);
                    });
            },
            addWage() {
                const wage = {
                    pspName: "pasargad",
                    from: "",
                    to: "",
                    wage: "",
                };
                this.newWages.push(wage);
            },
            deleteNewItem(wage) {
                const i = this.newWages.indexOf(wage);
                this.newWages.splice(i, 1);
            },
            registerNewItem(wage) {
                const el = $("#marketer_wage");
                let btn = $(`#register-new-wage${wage.id}`);
                KTApp.progress(btn);
            },
            uploadFile() {
                let formData = new FormData();
                let btn = $("#uploadBtn");
                KTApp.progress(btn);
                formData.append("file", this.excel);
                formData.append("psp", this.pspName);
                marketingService
                    .posSettingUploadExcel(formData)
                    .then((response) => {
                        KTApp.unprogress(btn);
                        this.toastr.success(response.data.message);
                    })
                    .catch(({ response }) => {
                        KTApp.unprogress(btn);
                        this.toastr.error(response.data.message);
                    });
            },
            createAcceptor() {
                ApiService.post(`marketing/pos-acceptor`, {
                    user_id:
                        this.create_acceptor_user_id !== null ? this.create_acceptor_user_id : null,
                    visitor_id: this.create_acceptor_visitor_id,
                    terminal_number: this.create_acceptor_terminal_number,
                    acceptor_code: this.create_acceptor_acceptor_code,
                    shop_name: this.create_acceptor_shop_name,
                    psp: this.create_acceptor_psp,
                    acceptor: {
                        user_type: this.create_acceptor_user_type,
                        first_name: this.create_acceptor_first_name,
                        last_name: this.create_acceptor_last_name,
                        com_name_fa: this.create_acceptor_com_name_fa,
                        phone: this.create_acceptor_phone,
                    },
                })
                    .then((response) => {
                        this.toastr.success(response.data.message);
                        $("#acceptosRegister").modal("hide");
                        this.create_acceptor_user_id = null;
                        this.create_acceptor_visitor_id = "";
                        this.create_acceptor_terminal_number = "";
                        this.create_acceptor_acceptor_code = "";
                        this.create_acceptor_shop_name = "";
                        this.create_acceptor_psp = "pasargad";
                        this.create_acceptor_user_type = "";
                        this.create_acceptor_first_name = "";
                        this.create_acceptor_last_name = "";
                        this.create_acceptor_com_name_fa = "";
                        this.create_acceptor_phone = "";
                    })
                    .catch(({ response }) => {
                        this.toastr.error(response.data.message);
                        for (let err in response.data.data) {
                            this.toastr.error(response.data.data[err][0]);
                        }
                    });
            },
        },
        mounted() {
            this.$store.dispatch("marketing/fetchPosStatistics");
            marketingService
                .getPosPublicWage()
                .then((response) => {
                    response.data.data.payload.psp_total_wage.pasargad.forEach((psp) => {
                        this.newWages.push({ ...psp, pspName: "pasargad" });
                    });
                    this.fetchPosWage = response.data.data.payload;
                    this.visitor_total_wage = this.fetchPosWage.visitor_total_wage;
                })
                .catch((error) => {
                    throw new Error(error)
                });
            userService.current().then((response) => {
                const getAccess = response.data.data.rules;
                if (getAccess.length) {
                    getAccess.find((access) => {
                        if (access.subject === "pos_visitor") {
                            this.active_pane = "#pos_acceptor_visitor";
                        } else if (access.subject === "marketing") {
                            this.active_pane = "#pos_agent";
                        } else {
                            this.active_pane = "#pos_acceptor_user";
                        }
                    });
                } else {
                    this.active_pane = "#pos_acceptor_user";
                }
            });
        },
    };
</script>

<style scoped>
    .line-divider {
        height: 1px;
        background-color: #777;
    }

    .sepread_part {
        border-bottom: 1px solid #9999;
    }

    .vSelect {
        --vs-actions-padding: 0;
        --vs-border-color: #fff;
    }

    .close_btn_modal {
        font-size: 20px;
        color: #333;
        cursor: pointer;
    }

    .switch-div {
        width: fit-content;
        padding: 8px 27px;
        background: #fff;
        box-shadow: 0 0 7px 0 #9c9c9c5e;
    }
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 20px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #6aad27;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 12px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    input:checked + .slider {
        background-color: #2196f3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196f3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }
    .slider.round {
        border-radius: 50px;
    }

    .slider.round:before {
        border-radius: 50px;
    }

    .info-icon {
        cursor: pointer;
        color: #0f9af0;
        display: inline-block;
    }

    #user_info > div.row > :first-child {
        border: none !important;
    }

    @media screen and (max-width:678px){
        .pos-tab li a{
            font-size: 9px !important;
        }
        .register-acceptor li button {
            font-size: 9px !important;
        }
    }
    @media screen and (max-width:400px){
        .pos-tab li a{
            font-size: 8px !important;
        }
        .register-acceptor li button {
            font-size: 8px !important;
        }
    }
</style>
